import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div>
      <div className="table">
        <table>
          <tr>
            <th className="col bor-bot" />
            <th colSpan={2}>praesens</th>
            <th colSpan={2}>imperfectum</th>
          </tr>
          <tr>
            <th className="col">1e ev.</th>
            <td>sum</td>
            <td>possum</td>
            <td>eram</td>
            <td>poteram</td>
          </tr>
          <tr>
            <th className="col">2e ev.</th>
            <td>es</td>
            <td>potes</td>
            <td>eras</td>
            <td>poteras</td>
          </tr>
          <tr>
            <th className="col">3e ev.</th>
            <td>est</td>
            <td>potest</td>
            <td>erat</td>
            <td>poterat</td>
          </tr>
          <tr>
            <th className="col">1e mv.</th>
            <td>sumus</td>
            <td>possumus</td>
            <td>eramus</td>
            <td>poteramus</td>
          </tr>
          <tr>
            <th className="col">2e mv.</th>
            <td>estis</td>
            <td>potestis</td>
            <td>eratis</td>
            <td>poteratis</td>
          </tr>
          <tr>
            <th className="col bor-bot">3e mv.</th>
            <td className="bor-bot">sunt</td>
            <td className="bor-bot">possunt</td>
            <td className="bor-bot">erant</td>
            <td className="bor-bot">poterant</td>
          </tr>
          <tr>
            <th />
            <td colSpan={2}>
              <em>
                ik ben
                <br />
                ik kan
              </em>
            </td>
            <td colSpan={2}>
              <em>
                ik was
                <br />
                ik kon
              </em>
            </td>
          </tr>
        </table>
      </div>

      <p>
        <Letop>
          Bij de bovenstaande tijden is het rijtje van <b>posse</b> eigenlijk
          hetzelfde als het rijtje van <b>esse</b>, maar dan met <b>pos-</b> of{" "}
          <b>pot-</b> ervoor.
        </Letop>
      </p>

      <div className="table">
        <table>
          <tr>
            <th className="col bor-bot" />
            <th colSpan={2}>perfectum</th>
          </tr>
          <tr>
            <th className="col">1e ev.</th>
            <td>fui</td>
            <td>potui</td>
          </tr>
          <tr>
            <th className="col">2e ev.</th>
            <td>fuisti</td>
            <td>potuisti</td>
          </tr>
          <tr>
            <th className="col">3e ev.</th>
            <td>fuit</td>
            <td>potuit</td>
          </tr>
          <tr>
            <th className="col">1e mv.</th>
            <td>fuimus</td>
            <td>potuimus</td>
          </tr>
          <tr>
            <th className="col">2e mv.</th>
            <td>fuistis</td>
            <td>potuistis</td>
          </tr>
          <tr>
            <th className="col bor-bot">3e mv.</th>
            <td className="bor-bot">fuerunt</td>
            <td className="bor-bot">potuerunt</td>
          </tr>
          <tr>
            <th />
            <td colSpan={2}>
              <em>
                ik ben geweest
                <br />
                ik heb gekund
              </em>
            </td>
          </tr>
        </table>
      </div>

      <p>
        <Letop>
          Het perfectum is compleet regelmatig, zolang je weet dat <b>fu-</b> de
          stam van <b>esse</b> is en <b>potu-</b> de stam van <b>posse</b> is.
        </Letop>
      </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/esse-posse-10.js